import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame", "menu"]
  static values = { url: String }

  pick(event) {
    event.preventDefault()
    event.stopPropagation()

    const city = event.currentTarget.dataset.city
    if (!city || !this.hasFrameTarget) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("city", city)
    this.frameTarget.src = url.toString()

    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden")
    }
  }
}
